export const tablet = 768;
export const desktop = 1024;
